import { shopServicePluginFactory } from '@/shared/services/ShopService'

export default shopServicePluginFactory()
